import Pagination from 'rc-pagination';
import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Col, Row } from 'reactstrap';
import RoutingList from '../../../components/RoutingList';
import { ENG_LOCALE } from '../../../lib/constants';

export default function Routing(props) {
  const {
    numbers,
    renderList,
    gateways,
    sort,
    handleQueryClick,
    handleQueryLrn,
    selectRoute,
    handleSortProvisioning,
    handleChangePagination,
    numberCarrierChangeAccess,
  } = props;

  const isReadOnly = numberCarrierChangeAccess === 'read';

  return (
    <>
      <Row>
        <Col md={12}>
          {numbers?.allNumbers?.docs && (
            <RoutingList
              handleQuery={handleQueryClick}
              queryLrn={handleQueryLrn}
              selectRoute={selectRoute}
              e911={renderList}
              gateways={gateways}
              sortValue={sort}
              onSort={handleSortProvisioning}
              isReadOnly={isReadOnly}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          {numbers.allNumbers.totalPages > 1 && (
            <Pagination
              locale={ENG_LOCALE}
              className="pagination-container"
              onChange={handleChangePagination}
              current={numbers.allNumbers.page}
              total={numbers.allNumbers.totalDocs}
              pageSize={numbers.allNumbers.limit}
              showLessItems
              showTitle={false}
              showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
            />
          )}
        </Col>
      </Row>
    </>
  );
}
